export default [
    {
        path: '/teacher/panel',
        name: 'teacher-panel',
        component: () => import('./pages/Index'),
        meta: {
            title: 'Painel do Docente',
            icon: 'mdi-view-dashboard-outline',
            breadcrumbs: [
                { text: 'Painel do Docente', disabled: true }
            ]
        }
    },
    {
        path: '/teacher/page',
        name: 'teacher/page',
        component: () => import('./pages/Index'),
        meta: {
            title: 'Painel do Docente',
            icon: 'mdi-view-dashboard-outline',
            breadcrumbs: [
                { text: 'Painel do Docente', disabled: true }
            ]
        }
    }
]

